import { useEffect, useState } from 'react';
import { api } from '../services/api';
import type { AvailabilityResponse } from '../types';

const EMPTY: AvailabilityResponse = {
  availabilityType: 'SlotBased',
  slots: [],
  operatingWindow: null,
};

export function useAvailableSlots(code: string, date: string | null, partySize: number) {
  const [data, setData] = useState<AvailabilityResponse>(EMPTY);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<Error | null>(null);

  useEffect(() => {
    if (!date || !partySize) {
      setData(EMPTY);
      return;
    }
    let cancelled = false;
    setLoading(true);
    setError(null);
    api
      .getAvailableSlots(code, date, partySize)
      .then((r) => !cancelled && setData(r))
      .catch((e) => !cancelled && setError(e))
      .finally(() => !cancelled && setLoading(false));
    return () => {
      cancelled = true;
    };
  }, [code, date, partySize]);

  return {
    availabilityType: data.availabilityType,
    slots: data.slots,
    operatingWindow: data.operatingWindow,
    loading,
    error,
  };
}
